import { toLocaleString4 } from '../strings'

export const overviewProductParser = (data: any[]): any[] => {
  const rows: any[] = []

  for (const entity of data) {
    rows.push({
      position: entity.posicao,
      codigo: entity.codigo,
      nome: entity.descricao,
      quantidade: entity.quantidade,
      valor: toLocaleString4(entity.valor)
    })
  }

  return rows
}
